import React, { useEffect, useRef, useState } from "react";
import styles from "./Parallax1.module.css";
import CommentTile from "./CommentTile";

const Parallax1 = () => {
  const parallaxRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isSafari, setIsSafari] = useState(false);

  useEffect(() => {
    // Detect Safari
    const ua = navigator.userAgent.toLowerCase();
    const isSafariBrowser =
      (ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1) ||
      /iPad|iPhone|iPod/.test(navigator.userAgent);
    setIsSafari(isSafariBrowser);

    const handleScroll = () => {
      if (parallaxRef.current) {
        const elementTop = parallaxRef.current.getBoundingClientRect().top;
        const elementHeight = parallaxRef.current.offsetHeight;
        const windowHeight = window.innerHeight;

        // Calculate how far into the element we've scrolled as a percentage
        const scrollPercentage =
          1 - elementTop / (windowHeight + elementHeight);
        setScrollPosition(window.scrollY);
      }
    };

    window.addEventListener("scroll", handleScroll);
    // Initial call to position elements correctly
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Calculate background position based on scroll
  const backgroundPositionY = `${10 + Math.min(scrollPosition * 0.05, 30)}%`;

  return (
    <div
      ref={parallaxRef}
      className={`${styles.container} ${
        isSafari ? styles.safariContainer : ""
      }`}
      style={{
        // Apply dynamic background position for Safari fallback
        ...(isSafari && { backgroundPositionY }),
      }}
    >
      <CommentTile />
    </div>
  );
};

export default Parallax1;
